import { Snackbar, Typography } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { FunctionComponent } from 'react';

export type AlertStatus = 'success' | 'error' | 'info' | 'warning' | undefined;

type Props = {
  copy: string | undefined;
  /** Do not auto hide alert. Default is to auto hide after 6 seconds. */
  persist?: boolean;
  status: AlertStatus;
  open: boolean;
  onClose?: (isOpen: boolean) => void;
};
const DEFAULT_AUTO_HIDE_DURATION = 6000;
export const AlertBar: FunctionComponent<Props> = (props) => (
  <Snackbar
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    open={props.open}
    onClose={() => {
      props.onClose?.(false);
    }}
    autoHideDuration={props.persist ? undefined : DEFAULT_AUTO_HIDE_DURATION}
  >
    <Alert elevation={6} variant="filled" severity={props.status}>
      <Typography variant="subtitle1">{props.copy}</Typography>
    </Alert>
  </Snackbar>
);
